import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=efd5aed8&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=efd5aed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd5aed8",
  null
  
)

export default component.exports